import cc from 'classcat';
import { useRef, useCallback, useEffect } from 'react';
import { PostloadedImage } from '@utils/react';
import { useIsPrintContent } from '../../print-context.js';
import { containerCls, imageCls, creditingCls } from './Image.style.js';
import { jsxs, jsx } from 'react/jsx-runtime';

const Image = ({
  sheetRef,
  pageId,
  pageAspectRatio,
  zIndex,
  item,
  isSelected,
  isCloned,
  onSelect,
  Before,
  After
}) => {
  const ref = useRef(null);
  const crediting = formatCrediting(item);
  const isPrintContent = useIsPrintContent();
  const handleSelect = useCallback(evt => {
    if (onSelect !== undefined) {
      onSelect(evt, item);
    }
  }, [item, onSelect]);
  useEffect(() => {
    const node = ref.current;
    if (node === null) {
      return;
    }
    node.addEventListener("mousedown", handleSelect, {
      passive: false
    });
    node.addEventListener("touchstart", handleSelect, {
      passive: false
    });
    return () => {
      node.removeEventListener("mousedown", handleSelect);
      node.removeEventListener("touchstart", handleSelect);
    };
  }, [item, handleSelect]);
  return /*#__PURE__*/jsxs("div", {
    ref: ref,
    className: cc([containerCls]),
    style: {
      zIndex,
      left: `${(item.position.x * 100).toString()}%`,
      top: `${(item.position.y * 100).toString()}%`,
      width: `${(item.size.width * 100).toString()}%`,
      height: `${(item.size.height * 100).toString()}%`,
      transform: item.angleInRadian !== 0 ? `rotate(${item.angleInRadian.toString()}rad)` : undefined
    },
    children: [Before !== undefined && /*#__PURE__*/jsx(Before, {
      sheetRef: sheetRef,
      pageId: pageId,
      pageAspectRatio: pageAspectRatio,
      isSelected: isSelected,
      isCloned: isCloned,
      item: item
    }), /*#__PURE__*/jsx(PostloadedImage, {
      alt: "",
      className: imageCls,
      src: item.src,
      showImmediately: isPrintContent,
      loading: isPrintContent ? "eager" : undefined
    }), crediting !== undefined && /*#__PURE__*/jsx("span", {
      className: creditingCls,
      children: crediting
    }), After !== undefined && /*#__PURE__*/jsx(After, {
      sheetRef: sheetRef,
      pageId: pageId,
      pageAspectRatio: pageAspectRatio,
      isSelected: isSelected,
      isCloned: isCloned,
      item: item
    })]
  });
};
function formatCrediting(image) {
  if (!image.settings.showCrediting) {
    return undefined;
  }
  let crediting = "";
  crediting = appendCreditingSegment(crediting, image.crediting.title);
  crediting = appendCreditingSegment(crediting, image.crediting.description);
  crediting = appendCreditingSegment(crediting, image.crediting.author);
  crediting = appendCreditingSegment(crediting, image.crediting.creditLine);
  crediting = appendCreditingSegment(crediting, image.crediting.year);
  return crediting.length > 0 ? crediting : undefined;
}
function appendCreditingSegment(crediting, segment) {
  const trimmedSegment = segment.trim();
  if (trimmedSegment.length === 0) {
    return crediting;
  }
  return crediting.length > 0 ? `${crediting}, ${trimmedSegment}` : trimmedSegment;
}

export { Image };
//# sourceMappingURL=Image.js.map
